<template>
  <svg
    width="124"
    height="124"
    viewBox="0 0 124 124"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0625 7.26562H7.26562V29.0625H0V0H29.0625V7.26562ZM94.9375 7.26562V0H124V29.0625H116.734V7.26562H94.9375ZM116.734 116.734H94.9375V124H124V94.9375H116.734V116.734ZM0 94.9375H7.26562V116.734H29.0625V124H0V94.9375ZM14.7734 14.5312V50.8594H51.1016V29.0625H58.3672V43.5938H65.6328V29.0625H58.3672V21.7969H65.6328V14.5312H58.3672V21.7969H51.1016V14.5312H14.7734ZM43.8359 43.5938H22.0391V21.7969H43.8359V43.5938ZM109.227 72.6562V108.984H72.8984V94.4531H65.6328V87.1875H72.8984V79.9219H65.6328V72.6562H87.4297V65.3906H94.6953V72.6562H109.227ZM94.6953 58.125H109.227V65.3906H94.6953V58.125ZM87.4297 58.125V65.3906H58.3672V50.8594H65.6328V58.125H87.4297ZM51.1016 72.6562H58.3672V65.3906H51.1016V58.125H14.7734V65.3906H29.3047V72.6562H22.0391V79.9219H14.7734V94.4531H22.0391V101.719H14.7734V108.984H22.0391V101.719H29.3047V108.984H65.6328V101.719H58.3672V94.4531H51.1016V101.719H36.5703V94.4531H43.8359V87.1875H51.1016V72.6562ZM51.1016 72.6562H43.8359V87.1875H36.5703V65.3906H51.1016V72.6562ZM22.0391 94.4531H29.3047V79.9219H22.0391V94.4531ZM87.4297 58.125V50.8594H72.8984V14.5312H109.227V50.8594H94.6953V58.125H87.4297ZM65.6328 79.9219V87.1875H58.3672V79.9219H65.6328ZM101.961 79.9219H80.1641V101.719H101.961V79.9219ZM36.5703 29.0625H29.3047V36.3281H36.5703V29.0625ZM87.4297 29.0625H94.6953V36.3281H87.4297V29.0625ZM80.1641 21.7969V43.5938H101.961V21.7969H80.1641ZM94.6953 87.1875H87.4297V94.4531H94.6953V87.1875Z"
      fill="#383F51"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
